module.exports = __webpack_public_path__ + "assets/img/page5-nav-item-3-da5d2352.png";